import * as T_T from 'cryface';
import { CommonConfig } from '../../../../configs/config.common';
import { AxiosPromise } from '../../../../utils/axios.promise';

// Not Injected, save Memory
export class UserInfoDelegate {

    private commonConfigs: CommonConfig = new CommonConfig();

    constructor() {
    }
    public userInfo = {
        uName: '',
        uGender: '',
        uPhone: '',
        uEmail: '',
        uImg: '',
        countryType: 38,
        zone_code: '',
        resPartnerId: null,
    };

    public async getUserInfo(fjjUserId: number): Promise<any> {
        const apiHost = this.commonConfigs.cmisapiHost;
        const body = {
            uid: fjjUserId,
            ltype: 1,
        };
        const fetched = await AxiosPromise.postJson(`${apiHost}/login/uid`, body);
        if (fetched.status === 200) {
            if (fetched.data.code === 200) {
                const data = fetched.data.data;
                return data;
            }
        }
        return null;
    }

}
